// ─────────────────────────────────────────────────────────────────────────────
// Compact "N left" pill for the marketing header. Renders inline next to
// the Sign In button so returning visitors browsing marketing pages see
// the countdown even after they've scrolled past the hero banner.
//
// Hidden when:
//   • Status not yet loaded (avoid layout jump)
//   • Remaining > 20 (bigger "we have room" window than the hero banner —
//     the pill is tighter real estate so we want to save it for real
//     urgency, but still catch users just past the hero threshold)
//   • Code is inactive
// Shown as "Full — join waitlist" when the cap is hit, linking down to
// the hero banner's waitlist form.
// ─────────────────────────────────────────────────────────────────────────────

import { usePromoStatus } from "../lib/usePromoStatus";

const CODE = "CALM100";

export const PromoHeaderPill = () => {
  const { status } = usePromoStatus(CODE);
  if (!status || !status.exists) return null;
  const { remaining, is_full } = status;
  if (!is_full && remaining > 20) return null;

  if (is_full) {
    return (
      <a
        href="/#promo-full-banner"
        className="hidden sm:inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-semibold bg-[#FEE2E2] text-[#B91C1C] border border-[#E11D48]/30 hover:bg-[#FECACA] transition"
        data-testid="promo-header-pill-full"
      >
        <span className="w-1.5 h-1.5 rounded-full bg-[#E11D48] animate-pulse" />
        Early access full — join waitlist
      </a>
    );
  }

  return (
    <span
      className="hidden sm:inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-semibold bg-[#FEF3C7] text-[#92400E] border border-[#F59E0B]/40"
      data-testid="promo-header-pill"
      aria-live="polite"
    >
      <span className="w-1.5 h-1.5 rounded-full bg-[#F59E0B] animate-pulse" />
      Only {remaining} early access {remaining === 1 ? "spot" : "spots"} left
    </span>
  );
};

export default PromoHeaderPill;
